export const getRandomEmojiShift = () => Math.floor(Math.random() * 15) - 7;
